import { createI18n } from 'vue-i18n'

import de from './locales/de'
import en from './locales/en'
import hr from './locales/hr'
import hu from './locales/hu'
import it from './locales/it'
import sl from './locales/sl'

export type AvailableLocales = 'sl' | 'en' | 'de' | 'it' | 'hr' | 'hu'

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           localStorage.getItem('locale') || 'sl',
    fallbackLocale:   'en',
    messages:         { sl, en, de, it, hr, hu },
    availableLocales: ['sl', 'en', 'de', 'it', 'hr', 'hu'],
})

export default i18n
